"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MERGED_NUTRIENT_LABELS = exports.USDA_NUTRIENT_LABELS = exports.FDA_NUTRIENT_LABELS = exports.USDA_PERCENTAGE_ROWS = exports.PRODUCT_COMPARE_DIMENSIONS = exports.PRODUCT_COMPARE_TABLE_STYLES = exports.X_PADDING = exports.PILL_Y = exports.PILL_X = exports.MAX_PRODUCT_CLAIMS_ROWS = exports.JSPDF_HEADING_STYLES = exports.JSPDF_TABLE_BASE_STYLES = exports.JSPDF_TYPE_BOLD = exports.JSPDF_TYPE_PLAIN = exports.BLACK = exports.GRAY = exports.LIGHT_GRAY = exports.WHITE = exports.FONT_NAME = exports.LOGO_HEIGHT = exports.LOGO_WIDTH = exports.TEXT_LINE_HEIGHT = exports.PARAGRAPH_FONT_SIZE = exports.HEADING_FONT_SIZE = exports.LINE_WIDTH = exports.PADDING = exports.FOOTER_HEIGHT = exports.HEADER_HEIGHT = exports.PAGE_CONTENT_WIDTH = exports.PAGE_MARGIN = exports.PAGE_WIDTH = exports.PAGE_HEIGHT = void 0;
exports.PAGE_HEIGHT = 792;
exports.PAGE_WIDTH = 612;
exports.PAGE_MARGIN = 20;
exports.PAGE_CONTENT_WIDTH = exports.PAGE_WIDTH - exports.PAGE_MARGIN * 2;
exports.HEADER_HEIGHT = 84;
exports.FOOTER_HEIGHT = 71;
exports.PADDING = 8;
exports.LINE_WIDTH = 1;
exports.HEADING_FONT_SIZE = 14;
exports.PARAGRAPH_FONT_SIZE = 12;
exports.TEXT_LINE_HEIGHT = 1.15;
exports.LOGO_WIDTH = 50;
exports.LOGO_HEIGHT = 48;
exports.FONT_NAME = "helvetica";
exports.WHITE = "#FFFFFF";
exports.LIGHT_GRAY = "#EBEBEB";
exports.GRAY = "#B6B6B6";
exports.BLACK = "#000000";
exports.JSPDF_TYPE_PLAIN = "plain";
exports.JSPDF_TYPE_BOLD = "bold";
exports.JSPDF_TABLE_BASE_STYLES = {
    fontSize: exports.PARAGRAPH_FONT_SIZE,
    fillColor: exports.WHITE,
    lineColor: exports.GRAY,
};
exports.JSPDF_HEADING_STYLES = {
    fontStyle: exports.JSPDF_TYPE_BOLD,
    cellPadding: {
        top: exports.PADDING,
        bottom: exports.PADDING,
    },
};
exports.MAX_PRODUCT_CLAIMS_ROWS = 5;
exports.PILL_X = 45;
exports.PILL_Y = 12;
exports.X_PADDING = 5;
const CENTER_H_ALIGN = "center";
const MIDDLE_V_ALIGN = "middle";
exports.PRODUCT_COMPARE_TABLE_STYLES = {
    fontSize: 10,
    cellPadding: 5,
    halign: CENTER_H_ALIGN,
    valign: MIDDLE_V_ALIGN,
};
exports.PRODUCT_COMPARE_DIMENSIONS = {
    firstColumnWidth: 112,
    productImageSize: 115,
    pillHeight: 15,
    pillWidth: 70,
    pillVerticalPadding: 5,
};
exports.USDA_PERCENTAGE_ROWS = [
    "Vitamin A",
    "Vitamin C",
    "Calcium",
    "Iron",
];
exports.FDA_NUTRIENT_LABELS = [
    "Total Fat",
    "Saturated Fat",
    "Trans Fat",
    "Cholesterol",
    "Sodium",
    "Total Carbohydrate",
    "Dietary Fiber",
    "Total Sugar",
    "Added Sugars",
    "Protein",
    "Vitamin D",
    "Calcium",
    "Iron",
    "Potassium",
];
exports.USDA_NUTRIENT_LABELS = [
    "Total Fat",
    "Saturated Fat",
    "Trans Fat",
    "Cholesterol",
    "Sodium",
    "Total Carbohydrate",
    "Dietary Fiber",
    "Total Sugar",
    "Protein",
    "Vitamin A",
    "Vitamin C",
    "Calcium",
    "Iron",
];
exports.MERGED_NUTRIENT_LABELS = [
    "Total Fat",
    "Saturated Fat",
    "Trans Fat",
    "Cholesterol",
    "Sodium",
    "Total Carbohydrate",
    "Dietary Fiber",
    "Total Sugar",
    "Added Sugars",
    "Protein",
    "Vitamin A",
    "Vitamin C",
    "Vitamin D",
    "Calcium",
    "Iron",
    "Potassium",
];
